import { createSlice } from "@reduxjs/toolkit";
import { 
    addDays,
    addWeeks,
    addMonths,
    subDays,
    subWeeks,
    subMonths,
    startOfMonth,
} from "date-fns";

const initialState = {
    mode: "light",
    user: null,
    token: null,
    //posts: [],
    calendar: {
        date: Date(),
        view: "month",
    },
    starredPeople: null,
    groups: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    toggleMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
        state.user = action.payload.user;
        state.token = action.payload.token;
    },
    setLogout: (state) => {
        state.user = null;
        state.token = null;
        state.calendar.date = Date();
        state.calendar.view = "month";
    },
    // workspace functions
    setAllWorkspaces: (state, action) => {
        state.user.allWorkspaces = action.payload.allWorkspaces;
    },
    setCurrentWorkspaces: (state, action) => {
        state.user.currentWorkspaces = action.payload.currentWorkspaces;
    },
    // calendar functions
    goToPrev: (state) => {
        switch (state.calendar.view) {
            case "day":
                state.calendar.date = subDays(new Date(state.calendar.date), 1).toString();
                break;
            case "week":
                state.calendar.date = subWeeks(new Date(state.calendar.date), 1).toString();
                break;
            case "month":
            case "agenda":
                state.calendar.date = subMonths( startOfMonth(new Date(state.calendar.date)) , 1 ).toString();
                break;
            default:
                break;
        }
    },
    goToNext: (state) => {
        switch (state.calendar.view) {
            case "day":
                state.calendar.date = addDays(new Date(state.calendar.date), 1).toString();
                break;
            case "week":
                state.calendar.date = addWeeks(new Date(state.calendar.date), 1).toString();
                break;
            case "month":
            case "agenda":
                state.calendar.date = addMonths(new Date(state.calendar.date), 1).toString();
                break;
            default:
                break;
        }
    },
    goToToday: (state) => {
        state.calendar.date = Date();
    },
    goToSpecificDate: (state, action) => {
        state.calendar.date = action.payload.date; // must pass in a string
    },
    setCalendarDate: (state, action) => {
        state.calendar.date = action.payload.date; // must pass in a string
    },
    setCalendarView: (state, action) => {
        state.calendar.view = action.payload.view;
    },
    // People functions
    setStarredPeople: (state, action) => {
        state.starredPeople = action.payload.starredPeople;
    },
    setGroups: (state, action) => {
        state.groups = action.payload.groups;
    },
  },
});

export const { 
    toggleMode, 
    setLogin, 
    setLogout, 
    setAllWorkspaces, 
    setCurrentWorkspaces, 
    goToPrev, 
    goToNext, 
    goToToday, 
    goToSpecificDate, 
    setCalendarDate, 
    setCalendarView,
    setStarredPeople,
    setGroups,
} = authSlice.actions;

export default authSlice.reducer;